export const GET_MY_EVENTS = "get_events"
export const GET_MY_EVENTS_SUCCESS = "get_events_success"